import React from "react";
import { FormRuntime } from "../../FormRuntime";
import { TimelineFormControl } from "../Web/TimelineFormControl";
import { XStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: TimelineFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let timeline = new TimelineFormControl();
    timeline.label = " Timeline With String";
    timeline.valueName = "timeline";
    timeline.timelineValues = ["Pizza", "Beer", "Fruits", "Kale"];
    container.add(timeline);

    return { form: ui, control: timeline };
}

export const TimelineStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["timeline"] = "Fruits";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Time Line",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["timeline"] = "Fruits";
            ui.control.labelSize = 15;

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Time Line",
        "Label Size",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["timelineValues"] = ["Beginner", "Junior", "Senior", "Master"];
            data.values["timeline"] = "Senior";
            ui.control.isVertical = true;
            ui.control.isDynamic = true;
            ui.control.stepsValueName = "timelineValues";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Time Line",
        "Steps From Data",
    ),
];
